/*
 * @Author: your name
 * @Date: 2021-08-23 14:25:37
 * @LastEditTime: 2021-09-02 14:01:24
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /qlchat-edu-offical-frontend/pages/pc-client/components/Layout/LayoutHead.tsx
 */
import React from 'react';
import Picture from '../../../../components/picture/Picture';
import { getDownloadQrDataUrl } from '../../../../lib/utils/downloadQrCode';
import { clickLog } from '../../../../lib/utils/UtilsYishuLog';
import { getOfficialSiteMenuClickEventId } from '../../../../lib/utils/UtilsOfficialSiteTrack';

/** props */
interface IProps {
	categoryList?: any;
	topicListEl?: any;
	region?: string;
	activeTab?: string;
	tabArr?: any;
	tabClick?: any;
}

/**
 * 页眉
 */
class LayoutHead extends React.PureComponent<IProps> {
	public state: any = {
		qrCodeSrc: '',
		tabList: [
			{
				name: '首页',
				code: 'home',
				url: '/',
			},
			{
				name: '公司简介',
				code: 'about',
				url: '/qlchat-edu/about',
			},
			{
				name: '业务介绍',
				code: 'business',
				url: '',
				children: [
					{
						name: '瑜伽学堂',
						code: 'category_75182625',
						url: '/qlchat-edu/category-module/75182625.html',
					},
					{
						name: '功法学堂',
						code: 'category_393378225',
						url: '/qlchat-edu/category-module/393378225.html',
					},
					{
						name: '摄影学堂',
						code: 'category_24671985',
						url: '/qlchat-edu/category-module/24671985.html',
					},
				],
			},
			{
				name: '公益责任',
				code: 'publicWelfare',
				url: '',
				children: [
					{
						name: '乡村图书室',
						code: 'ruralLibrary',
						url: '/qlchat-edu/public-welfare',
					},
					{
						name: '兴趣普惠',
						code: 'interestInclusion',
						url: '/qlchat-edu/public-welfare/interest-inclusion',
					},
					{
						name: '社会守护',
						code: 'socialGuardian',
						url: '/qlchat-edu/public-welfare/social-guardian',
					},
				],
			},
			{
				name: '新闻动态',
				code: 'news',
				url: '/qlchat-edu/news',
			},
		],
		active: '',
	};

	/**
	 * 客户端调用获取数据
	 *
	 * @memberof HomeTraining
	 */
	public async componentDidMount(): Promise<any> {
		// 获取动态下载二维码
		getDownloadQrDataUrl(208)
			.then((dataUrl) => {
				this.setState({ qrCodeSrc: dataUrl });
			})
			.catch(() => {
				// 失败则不显示二维码
			});

		let tab: any = sessionStorage.getItem('edu-home-active-tab');
		if (tab) {
			tab = JSON.parse(tab);
			this.setState(
				{
					active: tab.code,
				},
				(): any => {
					if (!tab.isCurUrl) {
						for (let i = 0; i < this.state.tabList.length; i++) {
							const item: any = this.state.tabList[i];
							for (let j = 0; j < item.children?.length; j++) {
								const child: any = item.children[j];
								if (child.code === tab.code) {
									this.clickTabToJump(child);
									break;
								}
							}
						}
					}
				},
			);
		}

		return {};
	}

	/**
	 * IE浏览器判断
	 */
	public iEVersion = (): any => {
		const userAgent: any = navigator.userAgent; // 取得浏览器的userAgent字符串
		const isIE: any = userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1; // 判断是否IE<11浏览器
		const isEdge: any = userAgent.indexOf('Edge') > -1 && !isIE; // 判断是否IE的Edge浏览器
		const isIE11: any = userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11.0') > -1;
		if (isIE) {
			return true;
		} else if (isEdge) {
			return true;
		} else if (isIE11) {
			return true;
		} else {
			return false;
		}
	};

	/**
	 * @description tabclick
	 */
	public clickTabToJump: any = (item, shouldTrack = false): void => {
		const { tabClick, tabArr } = this.props;
		const eventId = getOfficialSiteMenuClickEventId(item.code);
		if (shouldTrack && eventId) {
			clickLog({ event_id: eventId });
		}

		if (tabClick && tabArr) {
			tabClick(item);

			return;
		}
		let path: String = location.pathname;
		let isCurUrl: Boolean = path === item.url;
		item.isCurUrl = isCurUrl;
		if (
			item.code === 'home'
			|| item.code.includes('category_')
			|| item.code === 'more-courses'
		) {
			sessionStorage.setItem('edu-home-active-tab', JSON.stringify(item));
			if (isCurUrl) {
				window.scrollTo({ top: 0, behavior: 'smooth' });
			} else {
				location.href = item.url;
			}
		} else if (item.code === 'topic') {
			sessionStorage.setItem('edu-home-active-tab', JSON.stringify(item));
			if (isCurUrl) {
				if (!this.iEVersion()) {
					window.scrollTo({ top: 612, behavior: 'smooth' });
				} else {
					document.getElementById(item.code).scrollIntoView({ behavior: 'smooth' });
				}
			} else {
				location.href = item.url;
			}
		} else if (item.code === 'contact') {
			sessionStorage.setItem('edu-home-active-tab', JSON.stringify(item));
			if (isCurUrl) {
				document.getElementById(item.code).scrollIntoView({ behavior: 'smooth' });
			} else {
				location.href = item.url;
			}
		} else {
			if (!isCurUrl) {
				if (item.code === 'news') {
					sessionStorage.setItem('edu-home-active-tab', JSON.stringify(item));
				} else if (
					item.code === 'community'
					|| item.code === 'about'
					|| item.code === 'publicWelfare'
					|| item.code === 'ruralLibrary'
					|| item.code === 'interestInclusion'
					|| item.code === 'socialGuardian'
				) {
					sessionStorage.removeItem('edu-home-active-tab');
				}
				location.href = item.url;
			}
		}
		this.setState({
			active: item.code,
		});
	};
	/**
	 * render
	 */
	public render(): any {
		const { activeTab, tabArr } = this.props;
		const { tabList, active } = this.state;
		const list: any = tabList || tabArr;
		const activeBtn: any = active || activeTab || 'home';

		return (
			<div
				id="p-layout-head"
				className={`p-layout-head ${activeBtn === 'news' ? 'white-bg-news' : ''}`}
			>
				<div className="wrap">
					<a href="/">
						<img
							src="https://img.qlchat.com/qlLive/activity/image/6CN9M74R-U3R4-CJLE-1709892287468-KOZAOSMVM75D.png?x-oss-process=image/format,webp"
							className="ql-logo"
							alt=""
						/>
						{/* <img src="https://img.qlchat.com/qlLive/activity/image/D9KVNT5F-ZA1Z-MHW1-1717049642700-3XO3TXKBP8HJ.png" className="ql-logo-66" alt="兴趣岛66节" /> */}
					</a>
					<div className="p-layout-head-tab-link">
						{list.map((item: any, index: any): any => {
							return item.children && item.children.length > 0 ? (
								<div
									key={index}
									className={`tab-btn tab-btn-dropdown ${
										activeBtn === item.code
										|| item.children.some(
											(child: any): any => child.code === activeBtn,
										)
											? 'active'
											: ''
									}`}
								>
									<span>{item.name}</span>
									<div className="dropdown-menu">
										{item.children.map((child, childIndex) => (
											<div
												key={childIndex}
												className={`dropdown-item ${
													activeBtn === child.code ? 'active' : ''
												}`}
												onClick={(): any => {
													this.clickTabToJump(child, true);
												}}
											>
												{child.name}
											</div>
										))}
									</div>
								</div>
							) : (
								<div
									key={index}
									className={`tab-btn ${activeBtn === item.code ? 'active' : ''}`}
									onClick={(): any => {
										this.clickTabToJump(item, true);
									}}
								>
									{item.name}
								</div>
							);
						})}
						<div
							className="download-app"
							onClick={(): void => {
								clickLog({ event_id: 'click/downloadapp' });
							}}
						>
							下载APP
							<div className="download-app-popover">
								{this.state.qrCodeSrc ? (
									<img className="qr-code" src={this.state.qrCodeSrc} />
								) : null}
								<div className="download-tip">扫码下载APP</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

/**
 * mapStateToProps
 */
function mapStateToProps(state: any): any {
	return {};
}

const mapActionToProps: any = {};

export default LayoutHead;
